import React, { useState, lazy, Suspense } from "react";
import { IconButton, Tooltip } from "@mui/material";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import StyledDrawer from "../../../shared/UIParts/StyledDrawer";
import { Contact } from "../../../interfaces/DTO/crm/contact";
import { formatHandlerCode } from "../../../utils/namesFormater";
import { formatProductType } from "../../../utils/enumFormatter";

const ContactCommentsPanel = lazy(() => import("./ContactCommentsPanel"));

interface AddCommentButtonProps {
  contacts: Contact[];
  isFamily: boolean;
  reportedPeriod?: string;
  productType?: number;
  handlerCode?: string;
  policyNumber?: string;
}

const AddCommentButton: React.FC<AddCommentButtonProps> = ({
  contacts,
  isFamily,
  reportedPeriod,
  productType,
  handlerCode,
  policyNumber,
}) => {
  const [open, setOpen] = useState(false);

  const tooltipTitle = policyNumber
    ? `הוסף הערה לפוליסה ${policyNumber}`
    : handlerCode
    ? `הוסף הערה ליצרן ${formatHandlerCode(handlerCode)}`
    : productType != null
    ? `הוסף הערה למוצר ${formatProductType(productType)}`
    : "הוסף הערה";

  return (
    <>
      <Tooltip title={tooltipTitle} placement="top">
        <IconButton size="small" onClick={() => setOpen(true)}>
          <NoteAltOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <StyledDrawer
        open={open}
        onClose={() => setOpen(false)}
        onBack={() => setOpen(false)}
        width={420}
        anchor="left"
      >
        <Suspense fallback={null}>
          {open && (
            <ContactCommentsPanel
              contacts={contacts}
              isFamily={isFamily}
              reportedPeriod={reportedPeriod}
              productType={productType}
              handlerCode={handlerCode}
              policyNumber={policyNumber}
            />
          )}
        </Suspense>
      </StyledDrawer>
    </>
  );
};

export default AddCommentButton;
